import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-view-product',
    templateUrl: './view-product.component.html',
    styleUrl: './view-product.component.css',
    standalone: false
})
export class ViewProductComponent implements OnInit{

  public breadcrumb: any;
  options = {
    close: true,
    expand: true,
    minimize: true,
    reload: true
  };

  constructor() { }

  ngOnInit() {
    this.breadcrumb = {
      'mainlabel': 'Products',
      'links': [
        {
          'name': 'Home',
          'isLink': true,
          'link': '/dashboard/sales'
        },
        {
          'name': 'ChangeLog',
          'isLink': false,
          'link': '#'
        },
      ]
    };
  }

 
}
